import ReactDOM from "react-dom";

import { ApiSettings } from "@/Common/Api/ApiSettings";
import { Dispatcher } from "@/Common/Stores/Actions/ActionDispatcher";
import { CacheStore } from "@/Globals/Stores/CacheStore";
import { SessionStore } from "@/Globals/Stores/SessionStore";
import { NoteStore } from "@/Patient/Stores/NoteStore";
import { NotePage } from "../EntryPoints/NoteApp/NotePage";

export class NoteApp {
    public Load(elementId: string, rootPathArg: string, parentCacheStore: CacheStore, parentSessionStore: SessionStore, encounterId: string): void {
        window.rootPath = rootPathArg;
        window.apiSettings = new ApiSettings(baseURI + rootPathArg);

        // get settings from parent
        var wdw: any = window.opener;
        if (wdw != null) {
            var parentApiSettings = wdw.apiSettings as ApiSettings;
            apiSettings.setSession(parentApiSettings.ApiKey, parentApiSettings.SessionId, "parent session");
        }

        window.cacheStore = CacheStore.createSingletonFrom(parentCacheStore, false);
        window.sessionStore = SessionStore.createSingletonFrom(parentSessionStore);

        if (elementId == null || elementId == "") throw new TypeError("Element id must be provided");
        var elem = document.getElementById(elementId);
        if (elem == null || elem == undefined) throw new TypeError("HTML element by id not found");

        HandNoteModule.localNoteDispatcher = new Dispatcher<any>();
        HandNoteModule.serverNoteDispatcher = new Dispatcher<any>();
        HandNoteModule.noteStore = NoteStore.createSingleton();

        ReactDOM.render(
            <NotePage encounterId={encounterId} />,
            elem
        );
    }
}
